export default "__VITE_ASSET__L0EEM2Oa__"